import { FunctionComponent } from "react";
import * as Styled from "./logo.style";

export type LogoProps = {
	src: string;
};

export const Logo: FunctionComponent<LogoProps> = ({ src }) => (
	<Styled.Root src={src} />
);
